module.exports = __webpack_public_path__ + "img/percent.ad725c91.svg";